'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dekuRedux = require('@viskan/deku-redux');

var _components = require('./components');

var _components2 = _interopRequireDefault(_components);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = (0, _dekuRedux.connect)(function (state) {
	return {
		article: state.article,
		customer: state.customer,
		router: state.router,
		shopcart: state.shopcart
	};
})(_components2.default);

exports.default = { component: component, config: _config2.default };